import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { ROUTES } from "../../../constants";
import { NOTIFICATION_KEYWORDS, URL_PARAMS } from "../../../constants";
import { AuthService } from "../../../services/auth.service";
import { NotificationService } from "../../../services/notification.service";
import { UtilityService } from "../../../services/utility.service";
import { PasswordFieldComponent } from "../../../shared/password-field/password-field.component";
import { ActivatedRoute } from "@angular/router";

@Component( {
	selector: "app-reset-password",
	templateUrl: "./reset-password.component.html",
	styleUrls: [ "./reset-password.component.scss" ],
	changeDetection: ChangeDetectionStrategy.OnPush
} )

export class ResetPasswordComponent implements OnInit, OnDestroy {
	// this two variables might seem a litte odd, but it is to prevent the page from showing the wrong content while loading requests
	invalidCode: boolean = false;
	validCode: boolean = false;

	passwordValid: boolean = false;
	password: string = "";
	queryParams;

	@ViewChild(PasswordFieldComponent) private passwordField: PasswordFieldComponent;

	constructor(
		private formBuilder: FormBuilder,
		private notificationService: NotificationService,
		private spinnerService: NgxSpinnerService,
		private authService: AuthService,
		public utilityService: UtilityService,
		private activatedRoute: ActivatedRoute,
		private cdRef: ChangeDetectorRef
	) {
		this.activatedRoute.queryParams.subscribe((params) => {
			this.queryParams = params;
		});
	}

	ngOnInit(): void {
		this.spinnerService.show();
		this.authService.checkValidationCodeIsValid(this.queryParams[URL_PARAMS.CODE],
			this.queryParams[URL_PARAMS.EMAIL],
			this.queryParams[URL_PARAMS.TYPE]).subscribe(isValid => {
			if (isValid) {
				this.validCode = true;
				this.cdRef.detectChanges();
			} else {
				this.invalidCode = true;
				this.cdRef.detectChanges();
			}
			this.spinnerService.hide();
		}, error => this.spinnerService.hide() );
	}


	/**
	 * Function for the submission of a reset password form.
	 */
	submitResetPasswordForm(): void {

		const resetPasswordData = {
			email: this.queryParams[URL_PARAMS.EMAIL],
			code: this.queryParams[URL_PARAMS.CODE],
			password: this.password,
			confirmPassword: this.password
		};

		this.spinnerService.show();
		this.authService.resetPassword( resetPasswordData, this.queryParams[URL_PARAMS.TYPE]).subscribe( ( response ) => {
			if ( response ) {
				this.notificationService.successNotification( NOTIFICATION_KEYWORDS.RESET_PASSWORD );
				this.spinnerService.hide();
				this.utilityService.redirectToLoginPage();
			}
		}, ( error ) => {
			this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.RESET_PASSWORD );
			this.spinnerService.hide();
			if(this.queryParams[URL_PARAMS.EMAIL]){
				error.email = this.queryParams[URL_PARAMS.EMAIL];
			}
		} );
	}

	/**
	 * Handle resend password resetlink
	 */
	resetPasswordAgain() {
		const email = this.queryParams[URL_PARAMS.EMAIL];
		const data = {
			email
		};
		this.utilityService.redirectToLoginPage();
		this.spinnerService.show();
		this.authService.forgotPassword( data, this.queryParams[URL_PARAMS.TYPE] ).subscribe( ( response ) => {
			if ( response ) {
				this.notificationService.successNotification( NOTIFICATION_KEYWORDS.FORGOT_PASSWORD );
				this.spinnerService.hide();
				this.utilityService.navigate( ROUTES.LOG_IN );
			}
		}, ( error ) => {
			this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.FORGOT_PASSWORD );
			this.spinnerService.hide();
			this.utilityService.navigate( ROUTES.LOG_IN );
		} );
	}

	ngOnDestroy(): void {
		this.passwordField.reset();
	}
}
